// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"658":"2347c115","741":"cdbf93c8"}[chunkId] + ".chunk.js";
};